import helpers from "../helpers/helpers";
export default {
  modelName: 'change_item_template',
  versionModelName: 'change_item_template_version',
  versionTimestampKey: 'created_at',
  label: '變因',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    is_active: {
      type: 'switch',
      label: '顯示/隱藏',
      defaultValue: true,
      activeText: '顯示',
      inactiveText: '隱藏',
    },
    last_version: {
      type: 'last_version',
      // label: '變因資訊',
      modelName: 'change_item_template_version',
      showFields: ['name_mainlocale', 'updated_at'],
      fields: {
        locales: {
          type: 'locales',
          // label: "多語言內容",
          fields: {
            name: {
              type: 'text',
              label: '變因名稱',
              rules: 'required',
              maxlength: 30,
            },
            remark: {
              type: 'textarea',
              label: '說明',
              maxlength: 1000,
            },
            description: {
              type: 'textarea',
              label: '細部問題',
              maxlength: 1000,
            },
          },
        },
        system_classes: {
          label: '領域',
          type: 'hasMany',
          textKey: 'name',
          modelName: 'system_class',
          placeholder: '選擇領域分類',
          rules: 'required',
          hasCloseChips: true,
          requiredField: 'areas',
          conditionKeys: [
            {
              fieldName: 'areas',
              conditionName: 'area',
              type: 'areas',
            },
          ],
          sm: 6,
        },
        system_subclasses: {
          requiredField: 'system_classes',
          label: '子領域',
          type: 'hasMany',
          textKey: 'name',
          modelName: 'system_subclass',
          hasCloseChips: true,
          rules: 'required',
          conditionKeys: [
            {
              fieldName: 'system_classes',
              conditionName: 'system_class',
              type: 'array',
            },
          ],
          sm: 6,
        },
        risk_templates: {
          requiredField: 'system_subclasses',
          label: '變動風險評估項目',
          type: 'hasMany',
          textKey: 'name',
          modelName: 'risk_template',
          hasCloseChips: true,
          rules: 'required',
          conditionKeys: [
            {
              fieldName: 'system_subclasses',
              conditionName: 'system_subclass',
              type: 'array',
            },
          ],
        },
        updated_admin: {
          type: 'belongsTo',
          label: '最後更新人',
          textKey: 'name',
          readonly: true,
        },
        updated_at: {
          type: 'datetime',
          label: '更新時間',
          readonly: true,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    areas: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'areas',
      getUrl: 'area',
      requiredField: 'area_sections',
      multiple: true,
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      getText: (data) => {
        let result = ""
        data.forEach((_data) => {
          if (result !== "") {
            result += ","
          }
          result += _data.name
        })
        return result
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      }
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
      textKey: 'name',
    },
    industry_categories: {
      label: '適用產業類別',
      type: 'multi-layer',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (data) => {
        let result = ""
        data.forEach((_data) => {
          if (result !== "") {
            result += ","
          }
          result += _data.name
        })
        return result
      },
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'area',
            conditionName: 'area',
            type: 'number',
          },
        ],
      }
    },
    system_classes: {
      label: '涉及領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_class',
      placeholder: '選擇領域分類',
      rules: 'required',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      sm: 6,
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_class',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_class',
      label: '涉及子領域',
      type: 'hasMany',
      textKey: 'name',
      rules: 'required',
      modelName: 'system_subclass',
      sm: 6,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    range_type: {
      type: 'select',
      label: '適用範圍類型',
      items: [
        {
          value: 'general',
          text: '通用',
        },
        {
          value: 'exclusive',
          text: '專屬',
        },
      ],
      defaultValue: 'general',
    },
    factories: {
      type: 'hasMany',
      label: '適用工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return true
        } else if(modelData.range_type === "exclusive") {
          return false
        }
      },
    },
    exclusive_factories: {
      type: 'hasMany',
      label: '專屬工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return false
        } else if(modelData.range_type === "exclusive") {
          return true
        }
      },
      getRules: (modelData) =>{
        if (modelData.range_type === "exclusive") {
          return "required"
        } else {
          return null
        }
      }
    },
  },
};
